module.exports = __webpack_public_path__ + "img/arrow_up.7e9c8741.svg";